<template>
    <div>
        <OverlayModal
                :submitText="isAgent ? '' : 'Save'"
                :closeText="isAgent ? 'Close' : 'Cancel Changes'"
                @modalSubmitted="modalSubmitted"
                @modalClosed="closeModal">

            <div class="search-input-holder" v-if="!isAgent">
                <input type="text" class="form-control" v-model="searchQuery" id="search-input" autocomplete="off" />
                <a href="javascript:;" class="clear-search-btn" v-on:click="clearSearch()">Clear</a>
                <span class="library-counter"><strong>{{ librariesCounter }}</strong> Libraries Added</span>
                <span class="size-counter" style="float:right;">Total size: <strong>{{ parseFloat(sizeCounter).toFixed(2) + ' MB' }}</strong></span>
            </div>

            <div class="results">
                <div v-for="newLib of filteredLibraries" :value="newLib" :key="newLib._id" class="result">
                    <span class="result__lib-name">{{ newLib.name }}</span>

                    <template v-if="!isAgent">
                        <span class="result__action"><a href="javascript:;" v-on:click="removeLibrary(newLib._id)" v-if="hasLibrary(newLib._id)" style="color: red;">Remove</a></span>
                        <span class="result__action"><a href="javascript:;" v-on:click="addLibrary(newLib)" v-if="!hasLibrary(newLib._id)">Add</a></span>
                    </template>

                    <span class="result__size">({{ parseFloat(newLib.size).toFixed(2) + ' MB' }})&nbsp;&nbsp;</span>
                    <span style="clear: both; display: block; height:1px;"></span>
                </div>
            </div>
        </OverlayModal>
    </div>
</template>

<script>
import OverlayModal from '@/components/global/OverlayModal'
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'

export default {
    name: 'ManageLibrariesModal',
    props: ['userId', 'libraries'],
    components: {
        OverlayModal
    },
    computed: {
        ...mapStores(useAuthStore),
        isAgent() {
            return this.authStore.role === 'agent'
        }
    },
    data: function() {
        return {
            searchQuery: '',

            allLibraries: [],
            filteredLibraries: [],

            librariesCounter: 0,
            sizeCounter: 0,
            userLibraries: JSON.parse(JSON.stringify(this.libraries))
        }
    },
    created() {
        if (this.isAgent) {
            this.allLibraries = [...this.userLibraries]
            this.sortLibraries()
            this.filteredLibraries = this.allLibraries
        } else {
            this.axios.get(this.apiBase + '/libraries')
                  .then(response => {
                      this.allLibraries = response.data.data
                      this.sortLibraries()
                      this.filteredLibraries = this.allLibraries
                  })
                  .catch(error => {
                      alert('Could not load libraries!')
                      console.log(error)
                  })
        }
    },
    mounted() {
        this.focusSearchInput()
    },
    watch: {
        searchQuery(newValue) {
            if (newValue === '') {
                this.filteredLibraries = this.allLibraries
                return
            }
            this.filteredLibraries = this.searchInLibraries(newValue)
        }
    },
    methods: {
        focusSearchInput() {
            const searchInput = document.getElementById('search-input')
            if (searchInput) {
                searchInput.select()
            }
        },
        sortLibraries() {
            for (let i = 0; i < this.allLibraries.length; i++) {
                if (this.hasLibrary(this.allLibraries[i]._id)) {
                    this.librariesCounter++
                    this.sizeCounter += this.allLibraries[i].size
                    this.allLibraries.unshift(this.allLibraries.splice(i, 1)[0])
                }
            }
        },
        hasLibrary(id) {
            for (let i = 0; i < this.userLibraries.length; i++) {
                if (this.userLibraries[i]._id === id) {
                    return true
                }
            }
            return false
        },
        searchInLibraries(query) {
            let filteredResults = []
            for (let i = 0; i < this.allLibraries.length; i++) {
                if (this.allLibraries[i].name.toLowerCase().includes(query.toLowerCase())) {
                    filteredResults.push(this.allLibraries[i])
                }
            }
            return filteredResults
        },
        getLibraryIndex(libraryId) {
            for (let key in this.userLibraries) {
                if (this.userLibraries[key]['_id'] === libraryId) {
                    return key
                }
            }
            return -1
        },
        addLibrary(lib) {
            if (this.getLibraryIndex(lib._id) !== -1) {
                alert('Library already added')
                return
            }
            this.userLibraries.push(lib)
            this.librariesCounter++
            this.sizeCounter+= lib.size
            this.focusSearchInput()
        },
        removeLibrary(libraryId) {
            let index = this.getLibraryIndex(libraryId)
            if (index !== -1) {
                this.librariesCounter--
                this.sizeCounter -= this.userLibraries[index].size
                this.userLibraries.splice(index, 1);
            }
            this.focusSearchInput()
        },
        clearSearch() {
            this.searchQuery = ''
            this.focusSearchInput()
        },
        modalSubmitted() {
            //send data to backend
            const data = {
                'libraries': this.userLibraries
            }
            this.axios.patch(this.apiBase + '/users/' + this.userId, data)
            .then(response => {
                if (response.data.success !== true) {
                  alert('Error occurred')
                  console.log(response.data.data)
                }
                this.$emit('modalClosed', true, this.userLibraries)
            })
            .catch(error => {
                alert('Error occurred')
                console.log(error)
                this.$emit('modalClosed', true)
            })
        },
        closeModal() {
            this.$emit('modalClosed', false)
        }
    }
}
</script>

<style lang="scss">
.form-control {
    width: 100%;
    border-radius: 5px;
    padding: 5px 10px;
    box-sizing: border-box;
}

.results {
    max-height: 500px;
    overflow-y: auto;
    background: #eee;
    border-radius: 5px;
}
.result {
    border-bottom: 1px solid #aaa;
    padding: 0 5px;
    margin: 5px 0;
    &__lib-name {

    }
    &__action {
        float: right;
    }
    &__size {
        float: right;
    }

    clear: both;
}

.search-input-holder {
    position: relative;
    box-sizing: border-box;

    .clear-search-btn {
        position: absolute;
        right: 15px;
        top: 3px;
    }
}
</style>
